import Relay from 'react-relay';
/**
*  TurnOff lightGroup mutation
*/
export default class TurnOffLightGroupMutation extends Relay.Mutation {
  /**
  *  Mutation
  */
  getMutation() {
    return Relay.QL`mutation Mutation{
      turnOffLightGroup
    }`;
  }
  /**
  *  Variables
  */
  getVariables() {
    return {
        lightGroupId: this.props.lightGroupId,
    };
  }
  /**
  *  Fat query
  */
  getFatQuery() {
    return Relay.QL`
      fragment on turnOffLightGroupPayload @relay(pattern: true){
        clientMutationId,
        viewer{
            id
        }
      }
    `;
  }

  /**
  *  Config
  */
  getConfigs() {
    return [{
        type: 'FIELDS_CHANGE',
        fieldIDs: {
          viewer: this.props.viewer.id,
        },
    }];
  }

  static fragments = {
    viewer: () => Relay.QL`
      fragment on Viewer {
          id
      }
    `,
  };
}



// WEBPACK FOOTER //
// ./src/mutations/Venue/TurnOffLightGroupMutation.js